/**
 * どの経路にも当たらなかったURLを、「ページが見つかりません」へ寄せる。
 *
 * <h2>なぜ要るか</h2>
 *
 * Page404.vue は在るのに、**そこへ行く道が1本も無かった。**
 * URLを打ち間違える、古いブックマークを開く、メールの古いリンクを踏む——
 * どれも <b>完全な白紙</b>（body が0文字）になり、戻るボタン以外に
 * 出口が無い。左メニューすら出ない。
 *
 * <h2>登録の位置</h2>
 *
 * <b>順番は効かない。</b>「先に登録すると後の経路が食われる」と思って
 * 書いたが、<b>テストに否定された</b>。vue-router 3 は経路表を組むたびに
 * `*` を必ず末尾へ並べ替えるので（create-route-map.js）、addRoutes の
 * あとに足した経路がちゃんと勝つ。
 *
 * それでも main.js のいちばん下で呼ぶのは、<b>読む人にそう見えるほう</b>が
 * 迷わないから。並びに頼った守りではないので、上へ動かしても壊れない。
 *
 * <h2>redirect ではなく component で出す</h2>
 *
 * redirect にすると URL が /pages/404 に書き換わり、<b>何を開こうとして
 * 失敗したのかが消える</b>。問い合わせのときに「このURLを開いたら」が
 * 言えなくなるので、URLはそのままにして中身だけ差し替える。
 */
const Page404 = () => import('@/views/pages/Page404')

export default function registerNotFoundRoute (router) {
  if (!router || router.__preikaNotFoundRegistered) return
  router.__preikaNotFoundRegistered = true

  router.addRoutes([
    {
      path: '*',
      name: 'ページが見つかりません',
      component: Page404,
      meta: { public: true, pageTitle: 'ページが見つかりません' }
    }
  ])
}
